import { MinusIcon, PlusIcon } from '@heroicons/react/16/solid';
import { Button } from '../../../components/Form/Button';
import { useState } from 'react';
import { Input } from '@headlessui/react';
import { functionsCreateCheckoutSession } from '../../../shared/services/firestoreUtilities';
import { useOrganizationStore } from '../../../shared/organization/organizationStore';

const UserSelect = () => {
  const includedUsers = 5;
  const org = useOrganizationStore((state) => state.organization);
  const [userCount, setUserCount] = useState(includedUsers);
  const [loading, setLoading] = useState(false);
  if (!org) return null;
  if (!org.id) return null;
  const orgId = org.id;

  const updateUserCount = (increase: boolean) => {
    setUserCount((prevCount) => {
      if (increase) {
        return prevCount + 1;
      } else {
        return prevCount > includedUsers ? prevCount - 1 : includedUsers;
      }
    });
  };

  const handleCheckout = async () => {
    setLoading(true);
    try {
      await functionsCreateCheckoutSession(userCount - includedUsers, orgId);
    } catch (error) {
      console.error('Error creating checkout session:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <p className='text-xs'>
        To add more users beyond the included 5, please upgrade your
        subscription. Subscription price is calculated based on the total number
        of users.{' '}
        <i>(Users with viewer access do not count towards your subscription)</i>
      </p>
      <div className='flex items-center justify-between mt-6'>
        <Button
          type='button'
          variant='outline'
          className='w-full'
          onClick={() => updateUserCount(false)}
        >
          <MinusIcon className='h-5 w-5' />
          <span className='sr-only'>decrement user count</span>
        </Button>
        <Input
          type='number'
          className='text-3xl/10 font-medium tracking-tight text-gray-900 w-36 text-center appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
          value={userCount}
          onChange={(e) => {
            const value = parseInt(e.target.value, 10);
            if (!isNaN(value) && value >= includedUsers) {
              setUserCount(value);
            }
          }}
          min={5}
        ></Input>
        <Button
          type='button'
          variant='outline'
          className='w-full'
          onClick={() => updateUserCount(true)}
        >
          <PlusIcon className='h-5 w-5' />
          <span className='sr-only'>increment user count</span>
        </Button>
      </div>
      <div className='px-6 my-4'>
        <div className='flex items-center justify-between'>
          <span className='text-sm/6 font-medium mt-4'>Price per user</span>
          <span className='text-sm/6 font-medium text-gray-500 ml-2'>$10</span>
        </div>
        <div className='flex items-center justify-between border-b border-gray-200 pb-2'>
          <span className='text-sm/6 font-medium'>
            Number of additional users
          </span>
          <span className='text-sm/6 font-medium text-gray-500 ml-2'>
            {userCount - includedUsers}
          </span>
        </div>
        <div className='flex items-center justify-between mt-2'>
          <span className='text-center text-sm/6 font-medium '>
            Total Monthly Price:
          </span>
          <span className='text-sm/6 font-medium text-gray-500 ml-2'>
            ${(userCount - includedUsers) * 10}
          </span>
        </div>
      </div>
      <Button
        type='button'
        variant='primary'
        className='w-full mt-4'
        disabled={userCount <= includedUsers}
        loading={loading}
        onClick={handleCheckout}
      >
        <span className='text-base/6'>
          Purchase {userCount <= includedUsers ? '' : userCount - includedUsers}{' '}
          Users
        </span>
      </Button>
    </div>
  );
};
export default UserSelect;
